import { createTheme } from '@material-ui/core/styles'
import variables from './_variables.scss'
import { isRtl } from '../i18nInit'
import type {} from '@material-ui/lab/themeAugmentation'

export const primaryBlue = '#006FFF'

export const darkBlue = '#24284E'
export const lightBlue = '#82D1F8'
export const lighterBlue = '#E5F1FF'

export const darkGreen = '#318713'
export const darkerGreen = '#1A6300'
export const altGreen = '#39AF10'

export const successGreen = '#66B774'

export const lightGreen = '#96DDA3'
export const lighterGreen = '#A1E8AE'

export const notificationLightGreen = '#E7FFEB'
export const notificationLightBlue = '#E9F0FD'
export const notificationLightRed = '#FFE7EA'

//export const darkGreen = '#318713'
export const darkSuccess = '#067c00'

export const veryLightBlue = '#F2F8FF'
export const red = '#D7263D'
export const listLightBlue = '#F5F9FF'
export const gray = '#F5F5F9'
export const darkGray = '#CCCCCC'

const btnPrimaryBgHover = '#0084FF'
const btnPrimaryBgActive = '#3AA0FF'
const btnSecondaryBgHover = lighterBlue
const btnSecondaryBgActive = '#CBE2FF'

export const bgGray = '#F2F2F6'

export const Theme = createTheme({
  direction: isRtl ? 'rtl' : 'ltr',
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 992,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: primaryBlue,
    },
    secondary: {
      main: primaryBlue,
    },
    text: {
      primary: `${variables.primary_text_color}`,
      secondary: `${variables.secondary_text_color}`,
    },
    error: {
      main: red,
    },
    grey: { 500: gray },
  },
  typography: {
    fontFamily: `${variables.font_family}`,
    body1: {
      fontSize: 16,
      lineHeight: '20px',
      fontWeight: 'inherit',

      'html[dir=rtl] &': {
        textAlign: 'right',
      },
    },
    body2: {
      fontSize: '16px',
      lineHeight: '18px',
      fontWeight: 400,
    },
    h1: {
      fontSize: 36,
      lineHeight: '42px',
      fontWeight: 'normal',
      // @ts-ignore
      marginBottom: 25,
      // @ts-ignore
      whiteSpace: 'pre-line',
    },
    h2: {
      fontSize: 18,
      lineHeight: '18px',
      fontWeight: 'bold',
      // @ts-ignore
      marginBottom: 16,
    },

    subtitle1: {
      fontSize: 20,
      lineHeight: '26px',
      // @ts-ignore
      marginBottom: 25,
      /*'@media (max-width: 320px)': {
        fontSize: 16,
        lineHeight: '20px',
      }*/
    },
    subtitle2: {
      fontWeight: 'bold',
      fontSize: '16px',
      lineHeight: '18px',
      textAlign: 'left',
      // @ts-ignore
      marginBottom: 10,

      '@media (min-width: 992px)': {
        fontSize: 18,
      },

      'html[dir=rtl] &': {
        textAlign: 'right',
      },
    },
    caption: {
      fontWeight: 'bold',
      fontSize: '15px',
      lineHeight: '18px',
      textAlign: 'left',
      // @ts-ignore
      marginBottom: 10,
      '@media (min-width: 992px)': {
        fontSize: 19,
        lineHeight: '23px',
      },
    },
  },
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 0,
        marginBottom: 16,
      },
      marginDense: {
        marginTop: 0,
        marginBottom: 12,
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: gray,
      },
      root: {
        //color: darkGray,
        backgroundColor: gray,
        borderRadius: 10,
        '&:hover, &$focused': {
          backgroundColor: veryLightBlue,
        },
        '&:hover $notchedOutline': {
          borderColor: primaryBlue, //theme.palette.primary.main,
        },
        '&$focused $notchedOutline': {
          borderWidth: 1,
        },
        '&$error': {
          color: red,
        },
        '&$error$focused': {
          color: `${variables.primary_text_color}`,
        },
        '&$error$focused $notchedOutline': {
          borderColor: primaryBlue,
        },
        '&.Mui-disabled': {
          backgroundColor: gray,
          cursor: 'default',
        },
        '&.Mui-disabled $notchedOutline': {
          borderColor: gray,
        },
      },
      input: {
        fontSize: 16,
        paddingTop: '14.5px',
        paddingBottom: '14.5px',
        lineHeight: 1.5,
        '&::placeholder': {
          color: darkGray,
          opacity: 1,
        },
        '&:-webkit-autofill': {
          WebkitBoxShadow: '0 0 0 1000px #F5F5F9 inset',
        },
        'div:hover > &:-webkit-autofill, &:focus:-webkit-autofill': {
          WebkitBoxShadow: '0 0 0 1000px #F2F8FF inset',
        },
        '&.Mui-disabled': {
          cursor: 'default',
          color: darkBlue,
          '-webkit-text-fill-color': darkBlue,
          opacity: 1,
          paddingTop: '13px',
          paddingBottom: '13px',
          lineHeight: '22px',
          height: '22px',
        },
        'textarea&.Mui-disabled': {
          paddingTop: 2,
          paddingBottom: 3,
          //lineHeight: '18px',
          //height: '18px',
        },
      },
      adornedStart: {
        'html[dir=rtl] &': {
          //paddingLeft: 0,
          paddingRight: '14px',
        },
      },
      adornedEnd: {
        'html[dir=rtl] &': {
          //paddingRight: 0,
          paddingLeft: '14px',
        },
      },
      inputAdornedStart: {
        'html[dir=rtl] &': {
          paddingRight: 0,
        },
      },
    },
    MuiInputLabel: {
      filled: {
        fontSize: '16px',
        lineHeight: '18px',
        transform: 'translate(10px, 15px) scale(1) !important',

        'html[dir=rtl] &': {
          transformOrigin: '100% 0',
          transform: 'translate(-10px, 15px) scale(1) !important',
        },

        '&$shrink': {
          transform: 'translate(10px, 6px) scale(0.65) !important',

          'html[dir=rtl] &': {
            transformOrigin: '100% 0',
            transform: 'translate(-10px, 6px) scale(0.65) !important',
          },
        },
      },
      formControl: {
        'html[dir=rtl] &': {
          left: 'auto',
          right: 0,
        },
      },
    },
    /*MuiInput: {
      underline: {
        fontSize: '16px',
      },
    },*/
    MuiAutocomplete: {
      input: {
        marginRight: '25px',
        // marginRight: '55px',
      },
      endAdornment: {
        right: '7px',
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: gray,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
        borderBottomLeftRadius: 10,
        border: '1px solid transparent',
        '&:hover': {
          borderColor: primaryBlue,
          backgroundColor: veryLightBlue,
          '@media (hover: none)': {
            borderColor: 'transparent',
            backgroundColor: gray,
          },
        },
        '&$focused': {
          borderColor: primaryBlue,
          backgroundColor: veryLightBlue,
          '@media (hover: none)': {
            borderColor: `${primaryBlue}!important`,
            backgroundColor: `${veryLightBlue}!important`,
          },
        },
        '&.Mui-disabled': {
          borderColor: gray,
          backgroundColor: gray,
          cursor: 'default',
        },
        '&$error': {
          borderColor: red,
        },
      },
      input: {
        fontSize: '16px',
        lineHeight: '22px',
        height: 'auto',
        paddingTop: '22px',
        paddingBottom: '5px',
        paddingLeft: '10px',
        paddingRight: '10px',
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
        borderBottomLeftRadius: 10,
        '&::placeholder': {
          color: darkGray,
          opacity: 1,
        },
        '&:-webkit-autofill': {
          WebkitBoxShadow: '0 0 0 1000px #F5F5F9 inset',
        },
        'div:hover > &:-webkit-autofill, &:focus:-webkit-autofill': {
          WebkitBoxShadow: '0 0 0 1000px #F2F8FF inset',
        },
        '&.Mui-disabled': {
          cursor: 'default',
          color: darkBlue,
          '-webkit-text-fill-color': darkBlue,
          opacity: 1,
        },
        '&[type=date]': {
          height: '22px',
          //marginTop: '-2px',
          marginLeft: '-44px',
          //paddingLeft: '42px',
          paddingLeft: '44px !important',

          'html[dir=rtl] &': {
            marginLeft: 0,
            paddingLeft: 0,
            marginRight: '-44px',
            paddingRight: '44px !important',
            textAlign: 'right',
          },

          '&::-webkit-date-and-time-value': {
            textAlign: 'left',
            'html[dir=rtl] &': {
              textAlign: 'right',
            },
          },
        },
      },
      multiline: {
        paddingLeft: '10px',
        paddingRight: '10px',
        alignItems: 'flex-start',
        paddingTop: '19px !important',
        paddingBottom: '5px !important',
      },
      inputMultiline: {
        borderRadius: 0,
        lineHeight: '22px',
      },
      inputMarginDense: {
        paddingTop: '19px',
        paddingBottom: '5px',
      },
      adornedStart: {
        paddingLeft: '10px',

        'html[dir=rtl] &': {
          paddingLeft: 0,
          paddingRight: '10px',
        },

        /*'.date-range &': {
          padding: '0 !important',
        },*/
      },
      adornedEnd: {
        'html[dir=rtl] &': {
          paddingLeft: 12,
        },
      },
      inputAdornedStart: {
        // TODO: PROBLEMS WITH SELECT WITH ICON
        //paddingLeft: '0 !important',

        'html[dir=rtl] &': {
          paddingLeft: '10px !important',
          //paddingRight: '0 !important',
        },
      },
    },
    MuiInputBase: {
      root: {
        verticalAlign: 'bottom',
      },
    },
    MuiSelect: {
      filled: {
        paddingBottom: '5px',
        paddingRight: '19px',
        borderRadius: '0 !important',

        'html[dir=rtl] &': {
          paddingRight: '10px',
          paddingLeft: '19px !important',
        },

        '&:hover': {
          '@media (hover: none)': {
            backgroundColor: 'transparent !important',
          },
        },
      },
      /*iconFilled: {
        padding: '19px 32px 5px 0 !important',
      },*/
      select: {
        display: 'inline-block',
        margin: 0,
        //borderRadius: '25px !important',
        //padding: '0 24px 0 10px !important',
        padding: '0 24px 0 10px',
        lineHeight: '24px',
        height: '24px',
        fontSize: '10px',
        fontWeight: 700,
        width: '100%',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        borderWidth: '1px',
        borderStyle: 'solid',

        'html[dir=rtl] &': {
          padding: '0 10px 0 24px',
        },

        borderColor: primaryBlue,
        backgroundColor: primaryBlue,
        color: 'white',

        '&:hover': {
          borderColor: btnPrimaryBgHover,
          backgroundColor: btnPrimaryBgHover,
          '@media (hover: none)': {
            borderColor: `${primaryBlue} !important`,
            backgroundColor: `${primaryBlue} !important`,
          },
          '&.MuiTablePagination-select': {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
          },
        },
        '&:active': {
          borderColor: btnPrimaryBgActive,
          backgroundColor: btnPrimaryBgActive,
          '@media (hover: none)': {
            borderColor: `${btnPrimaryBgActive} !important`,
            backgroundColor: `${btnPrimaryBgActive} !important`,
          },
          '&.MuiTablePagination-select': {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
          },
        },
        '&:focus': {
          borderRadius: '25px',
          backgroundColor: primaryBlue,
        },

        '&.MuiSelect-outlined': {
          borderColor: primaryBlue,
          backgroundColor: 'white',
          color: primaryBlue,

          '&:hover': {
            borderColor: primaryBlue,
            backgroundColor: btnSecondaryBgHover,
            '@media (hover: none)': {
              backgroundColor: `white !important`,
            },
          },
          '&:active': {
            borderColor: primaryBlue,
            backgroundColor: btnSecondaryBgActive,
            '@media (hover: none)': {
              backgroundColor: `${btnSecondaryBgActive} !important`,
            },
          },
        },
      },
      iconFilled: {
        'html[dir=rtl] &': {
          left: '7px',
          right: 'auto',
        },
      },
    },
    MuiInputAdornment: {
      root: {
        fontSize: '16px',

        /*'.date-range & svg': {
          marginLeft: '10px',

          /!*'html[dir=rtl] &': {
            paddingRight: '10px',
            paddingLeft: 0,
          },*!/
        },*/
      },
      positionStart: {
        color: darkGray,
        // Focus the input when the icon is clicked
        pointerEvents: 'none',

        'html[dir=rtl] &': {
          marginLeft: '8px',
          marginRight: 0,
        },
      },
      positionEnd: {
        'html[dir=rtl] &': {
          marginLeft: 0,
          marginRight: '8px',
        },
      },
    },
    MuiIconButton: {
      root: {
        paddingTop: '10px',
        paddingBottom: '10px',
      },
      edgeEnd: {
        color: darkGray,
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.03)',
          '@media (hover: none)': {
            backgroundColor: 'transparent',
          },
        },
        /* TODO: multiline stuff */
        'textarea + div &': {
          marginTop: '7px',
          marginRight: '-10px',
        },

        'html[dir=rtl] &': {
          marginLeft: '-12px',
          marginRight: 'auto',
        },
      },
    },
    MuiButton: {
      root: {
        display: 'inline-block',
        textAlign: 'center',
        border: 0,
        height: '32px',
        borderRadius: '8px',
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: '16px',
        textTransform: 'none',
        padding: '6px 10px',
      },
      text: {
        background: 'white',
        color: primaryBlue,
        minWidth: '36px',
        padding: '6px 10px',
      },
      containedPrimary: {
        backgroundColor: primaryBlue,
        '&:hover': {
          backgroundColor: btnPrimaryBgHover,
          '@media (hover: none)': {
            backgroundColor: primaryBlue,
          },
        },
        '&:active': {
          backgroundColor: btnPrimaryBgActive,
          '@media (hover: none)': {
            backgroundColor: `${btnPrimaryBgActive} !important`,
          },
        },
      },
      outlined: {
        backgroundColor: '#ffffff',
      },
      outlinedPrimary: {
        color: primaryBlue,
        borderColor: primaryBlue,
        '&:hover': {
          borderColor: primaryBlue,
          backgroundColor: btnSecondaryBgHover,
          '@media (hover: none)': {
            backgroundColor: '#ffffff',
          },
        },
        '&:active': {
          borderColor: primaryBlue,
          backgroundColor: btnSecondaryBgActive,
          '@media (hover: none)': {
            backgroundColor: `${btnSecondaryBgActive} !important`,
          },
        },
      },
      sizeSmall: {
        /*width: 'auto',
        minWidth: 57,
        fontSize: 12,
        borderRadius: 32,
        lineHeight: '23px',*/
        margin: 0,
        minWidth: 'auto',
        width: 'auto',
        padding: '0 12px',
        lineHeight: '26px',
        height: '26px',
        fontSize: 10,
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        textTransform: 'uppercase',
        borderRadius: 25,
        '& svg': {
          verticalAlign: 'middle',
        },
      },
      sizeLarge: {
        fontWeight: 500,
        padding: '6px 16px',
        fontSize: '14px',
        height: 'auto',
        borderRadius: 25,
        width: 185,
        lineHeight: '36px',
        margin: '0 auto 16px',
        textTransform: 'uppercase',
        display: 'block',
        '& svg': {
          verticalAlign: 'middle',
        },
      },
      textSecondary: {
        '&:hover': {
          backgroundColor: 'rgba(255,255,255,.5)',
          '@media (hover: none)': {
            backgroundColor: '#ffffff',
          },
        },
        '&:active, &:focus': {
          backgroundColor: 'rgba(255,255,255,.5)',
          '@media (hover: none)': {
            backgroundColor: `rgba(255,255,255,.5) !important`,
          },
        },
      },
      containedSecondary: {
        transition:
          'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, opacity 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        backgroundColor: `${darkGreen} !important`,
        //backgroundColor: success,
        '&:hover': {
          opacity: 0.9,
          '@media (hover: none)': {
            opacity: 1,
          },
        },
        '&:active': {
          opacity: 0.7,
          '@media (hover: none)': {
            opacity: 1,
          },
        },
      },
      label: {
        '& svg': {
          verticalAlign: 'bottom',
        },
      },
    },
    MuiLink: {
      underlineAlways: {
        //fontSize: '12px',
        lineHeight: '18px',
        textDecoration: 'none',
        borderBottom: `1px solid ${primaryBlue}`,
      },
      underlineHover: {
        '&:hover': {
          textDecoration: 'none',
          borderBottom: `1px solid ${primaryBlue}`,
        },
      },
    },
    MuiBackdrop: {
      root: {
        backgroundColor: 'rgba(36, 40, 78, 0.2)',
        backdropFilter: 'blur(5px)',
      },
    },
    MuiDrawer: {
      paper: {
        backgroundColor: '#ffffff',
        borderTopLeftRadius: '30px',
        borderTopRightRadius: '30px',
        padding: '22px 15px 34px 15px',
        width: '100%',
        maxWidth: 600,
        margin: '0 auto',
      },
      paperAnchorBottom: {
        maxHeight: '80vh',
      },
    },
    MuiList: {
      root: {
        //marginBottom: 16,
      },
      padding: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    MuiListItem: {
      root: {
        flexWrap: 'wrap',
        //backgroundColor: '#FFCB79',
        //backgroundColor: listLightBlue,
        borderRadius: 10,
        marginBottom: 12,
        paddingTop: 9,
        paddingBottom: 9,
        border: '1px solid transparent',
        backgroundColor: 'white',
        textAlign: 'left',

        'html[dir=rtl] &': {
          textAlign: 'right',
        },
      },
      button: {
        backgroundColor: gray,
        '&:hover, &$selected, &$selected:hover': {
          backgroundColor: listLightBlue,
          borderColor: primaryBlue,
          //fontWeight: 600,
        },
        '&:hover': {
          backgroundColor: listLightBlue,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: listLightBlue,
          },
        },
      },
      gutters: {
        paddingLeft: 10,
        paddingRight: 10,
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: 24,
      },
    },
    MuiListItemText: {
      root: {
        marginLeft: '10px',
        marginRight: '10px',
      },
      primary: {
        fontSize: '16px',
      },
      secondary: {
        //fontSize: '14px',
      },
    },
    /*PrivateSwitchBase: {
      root: {
        padding: '10px',
      },
    },*/
    MuiTooltip: {
      tooltip: {
        backgroundColor: red,
        color: '#ffffff',
      },
      tooltipPlacementTop: {
        top: 15,
        //'@media (min-width: 768px)': {
        '@media (min-width: 375px)': {
          top: 5,
        },
      },
      arrow: {
        color: red,
      },
    },
    MuiChip: {
      root: {
        marginRight: '10px',
        marginBottom: '10px',
        borderColor: listLightBlue,
        backgroundColor: listLightBlue,
        borderWidth: '1px',
        borderStyle: 'solid',
      },
      clickable: {
        '&:active': {
          boxShadow: 'none',
        },
        '&:hover': {
          backgroundColor: listLightBlue,
          borderColor: primaryBlue,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            borderColor: listLightBlue,
          },
        },
        '&:focus': {
          backgroundColor: listLightBlue,
        },
      },
      colorPrimary: {
        color: 'white',
        borderColor: primaryBlue,
      },
      colorSecondary: {
        color: 'white',
        backgroundColor: red,
      },
      outlined: {
        backgroundColor: listLightBlue,
        borderColor: `${primaryBlue} !important`,
        //color: primaryBlue,
      },
    },
    MuiSwitch: {
      /*root: {
        '& $checked': {
          '& + $track': {
            backgroundColor: `${variables.success_color}`,
          },
          color: `${variables.success_color}`,
        },
        switchBase: {
          '& + $track': {
            backgroundColor: `${variables.disabled_color}`,
          },
          color: `${variables.disabled_color}`,
        },
      },*/
      colorPrimary: {
        //color: `#F5F5F9 !important`,
        /*'&$checked': {
          color: `${red} !important`,
        },*/
        '&$checked + $track': {
          backgroundColor: `${darkGreen} !important`,
        },
      },
      colorSecondary: {
        /*color: `#F5F5F9 !important`,
        '&$checked': {
          color: `${red} !important`,
        },*/
        '&$checked + $track': {
          backgroundColor: `${red} !important`,
        },
      },
      track: {
        opacity: 0.2,
      },
    },
    MuiMenuItem: {
      root: {
        marginBottom: 0,
        fontSize: 13,
        lineHeight: '24px',
        padding: '4px 16px',
        fontWeight: 400,
        minHeight: 'auto',
        border: 'none',
        borderRadius: 0,
        borderTop: '1px solid #EDEFF6 !important',
        backgroundColor: 'transparent !important',
        '&$selected, &&:hover': {
          color: primaryBlue,
          fontWeight: 400,
        },
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: '16px',
      },
      root: {
        marginLeft: '-8px',
        'html[dir=rtl] &': {
          marginLeft: '16px',
          marginRight: '-8px',
        },
      },
    },
    MuiAccordion: {
      root: {
        backgroundColor: gray,
        marginBottom: '12px !important',
        border: `1px solid ${gray}`,
        '&$expanded, &:hover': {
          border: `1px solid ${primaryBlue}`,
          marginTop: 0,
        },
        '&:before': {
          content: 'none',
        },
      },
      rounded: {
        borderRadius: '10px',
        '&:first-child': {
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
        },
        '&:last-child': {
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px',
        },
      },
    },
    MuiAccordionSummary: {
      root: {
        padding: '0 10px',
        minHeight: '46px',
        '&$expanded': {
          minHeight: '46px',
        },
        '&$focused': {
          borderRadius: '10px',
        },
      },
      content: {
        alignItems: 'center',
        margin: '11px 0',
        '&$expanded': {
          margin: 0,
        },
      },
    },
    MuiAccordionDetails: {
      root: {
        padding: '12px 10px 12px 10px',
      },
    },
    MuiStepper: {
      vertical: {
        padding: 0,
      },
    },
    MuiStepContent: {
      root: {
        'html[dir=rtl] &': {
          borderLeft: 'none',
          borderRight: '1px solid #bdbdbd',
          marginLeft: 0,
          marginRight: 12,
          paddingLeft: 8,
          paddingRight: 20,
        },
      },
    },
    MuiStepConnector: {
      vertical: {
        //padding: 0,
        'html[dir=rtl] &': {
          marginLeft: 0,
          marginRight: 12,
        },
      },
      lineVertical: {
        //minHeight: '12px',
        minHeight: 5,
        /*'&$completed': {
          minHeight: 0,
        },*/

        'html[dir=rtl] &': {
          borderLeftWidth: 0,
          borderRightStyle: 'solid',
          borderRightWidth: '1px',
        },
      },
      /*completed: {
        '& .MuiStepConnector-line': {
          minHeight: 0,
        },
      },*/
    },
    MuiStepIcon: {
      text: {
        fontSize: '12px',
      },
    },
    MuiStepLabel: {
      root: {
        marginBottom: '8px',
      },
      active: {
        color: `${primaryBlue} !important`,
      },
      iconContainer: {
        paddingRight: '8px',

        'html[dir=rtl] &': {
          paddingRight: '0',
          paddingLeft: '8px',
        },
      },
    },
    MuiFormHelperText: {
      root: {
        fontSize: '12px !important',
        lineHeight: '20px !important',
        fontWeight: 400,

        'html[dir=rtl] &': {
          textAlign: 'right',
        },
      },
      contained: {
        marginLeft: 10,
        marginRight: 10,
      },
    },
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
})
